<template>
    <div id="chart-area">
            <apexchart 
            type="line" 
            height="700" 
            :options="chartOptions" 
            :series="series">
            </apexchart>
      </div>
</template>

<script>
import { mapState } from "vuex"
import { getLightColor } from '@/utils.js'


export default {
    name : "ChartRawCBC",
    props:{
        rawCBCData : Array,
        cusNoToChild : String,  // "cus0", "cus1" ,"cus2"
    },
    computed:{
        ...mapState({
             dataLabParamsMaster : state => state.master_data.dataLabParamsMaster,
             dataLabParamsMaster_1 : state => state.master_data.dataLabParamsMaster_1,
             dataLabParamsMaster_2 : state => state.master_data.dataLabParamsMaster_2,
        }),


        keyVisible(){
            if (this.cusNoToChild  == "cus1"){
                return   this.dataLabParamsMaster_1.filter(dat=>dat.isSwitchedCUS1) 
                                             .map(dat=>dat.key)  
            }else if (this.cusNoToChild  == "cus2"){
                return   this.dataLabParamsMaster_2.filter(dat=>dat.isSwitchedCUS1) 
                                             .map(dat=>dat.key)  
            }
            return   this.dataLabParamsMaster.filter(dat=>dat.isSwitchedCUS1) 
                                             .map(dat=>dat.key)  
        },
        dataFilterSomeColumn(){
       
          
          let tmp_return = []
          tmp_return = this.rawCBCData.map(item=>{
             // { "idlab": "66103387", "date_req": "10/04/2023", "time_req": "04:19:31 pm", "date_report": "2023-04-11", "time_report": "19:52:09", "hm_hgb": "12.30"
              let tmp = {
                 "idlab" : item.idlab  ,
                 "date_req": item.date_req  ,
                 "time_req": item.time_req  ,
                 "date_report": item.date_report  ,
                 "time_report": item.time_report  
              }
              for (const [key] of Object.entries(  item )) {
                if (this.keyVisible.indexOf(key)>-1){
                    // console.log('item---> ',item[key])
                    // add new for only wanted
                    tmp[key] = item[key]
                }
              }
             return tmp     
           })
           return tmp_return
        }, 


         series(){
            let tmp_return = []

            for(var i =0;i<=this.keyVisible.length-1;i++){
                tmp_return.push(
                                { 
                                    name: this.getLabelFromKey (this.keyVisible[i]),
                                    data: this.dataFilterSomeColumn.map(dat=> {
                                      return dat[this.keyVisible[i]] != "" ? parseFloat(dat[this.keyVisible[i]]) : null
                                    }  )
                                }
                )
                          
            }
            


            return tmp_return
          
         
        }  , 


        chartOptions() {
          return{
                  chart: {
                    height: '700',
                    type: 'line',
                    zoom: {
                      enabled: false
                    },
                    animations: {
                      enabled: false
                    }
                  },
                  // colors:  this.getColorArrForKeyVisible(),
                  stroke: {
                    // width: [5,5,4],
                    curve: 'straight'
                  },
                  labels:  this.dataFilterSomeColumn.map(dat=>dat.idlab ) ,
                  title: {
                    text: ''
                  },
                  xaxis: {
                  }

          }



          },



          
           
    },


    methods:{
        getLabelFromKey(_key){
          return   this.dataLabParamsMaster.find(dat=>dat.key==_key)
                                           .label
        },
        getColorArrForKeyVisible(){
          let arr = [] 
        
          for(var i=0;i<=this.keyVisible.length-1 ;i++){
            // console.log(getHardColor(i))
            arr.push(getLightColor(i))
          }
          return arr 

              
        }
    },

    data(){
        return{


        }
    }
}
</script>